/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import '../blog/blog.scss';
import PageHeader from '../../layouts/page-header/PageHeader';
import Pagination from '../../component/pagination';
import Loading from '../../component/Loading';
import { HiOutlineEye } from 'react-icons/hi2';
import { bilimMerkezAPI } from '../../api';

const Announcements = () => {
  const [data, setData] = useState([]);
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const lang = language === 'tk' ? 'tm' : language;

  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  // get current page from URL
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get('page')) || 1;

  const handlePageChange = (pageNumber) => {
    setSearchParams({ page: pageNumber });
  };

  const limit = 20;
  const offset = (currentPage - 1) * limit;

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await bilimMerkezAPI.get(`/notices`, {
          params: {
            lang,
            limit,
            offset,
          },
        });
        setData(res.data?.results || []);
        setCount(res.data?.count || 0);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [lang, currentPage]);

  const getLocalizedTitle = (item) => {
    switch (lang) {
      case 'tm':
        return item.title_tm;
      case 'ru':
        return item.title_ru;
      case 'en':
        return item.title_en;
      case 'ko':
        return item.title_ko;
      default:
        return item.title_tm;
    }
  };

  return (
    <div className="site-content">
      <PageHeader
        colSize="col-md-10"
        title={t('announcements')}
        PagaHeaderBg="/images/bg.svg"
        breadCrumbItems={[{ label: t('home'), path: '/' }]}
      />

      <div className="event-ara page-template content-wrapper">
        <div className="container">
          {loading ? (
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Loading style={{ width: '10%' }} />
            </div>
          ) : (
            <div className="row">
              <div className="col-sm-12">
                <div className="grid-wrapper grid-lg-2 grid-md-1">
                  {data.length > 0 &&
                    data.map((item) => (
                      <Link
                        to={`/announcement-details/${item?.slug || ''}`}
                        key={item.id}
                        className="single-item"
                      >
                        <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row tw-gap-4 tw-group">
                            <div className="md:tw-basis-1/2 tw-aspect-[3/2]">

                              {item.image && (
                                <img
                                  className="tw-w-full tw-aspect-[3/2] tw-object-contain"
                                  src={item.image}
                                  alt={getLocalizedTitle(item)}

                                />
                              )}
                            </div>
                          <div className="tw-basis-1/2 tw-p-4 tw-flex tw-flex-col tw-justify-between">
                            <div className="tw-max-h-lg tw-text-black tw-font-bold">
                              <div className="tw-line-clamp-4 tw-transition-colors tw-duration-300 group-hover:tw-text-primary">
                                {getLocalizedTitle(item)}
                              </div>
                            </div>
                            <div className="tw-justify-self-end tw-flex tw-flex-row tw-justify-end tw-items-center tw-gap-1.5 tw-text-gray-400">
                              <HiOutlineEye className="tw-size-6"/>
                              <div>{item.views ?? 0}</div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))}
                </div>
              </div>
            </div>
          )}
        </div>

        <Pagination
          currentPage={currentPage}
          count={count}
          limit={limit}
          handlePageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default Announcements;
